/* angular:styles/component:css;9092cbc6cce1eac5fce99e963c5870632bc0ecd8800c71dd6f34f336e1cf60a4;/Users/stevennaimark/devtoil/Ziptility/Bivvy/src/app/feature/asset-profile-header.component.ts */
.bv-panel-tabs {
  display: flex;
  border-top: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
  justify-content: center;
  align-items: center;
}
.bv-panel-tabs .bv-panel-tabs__button {
  flex-grow: 1;
  display: inline-block;
  padding: 10px;
  background: #f9fafb;
  font-size: 12px;
  border-bottom: 2px solid transparent;
}
.bv-panel-tabs .bv-panel-tabs__button.active {
  border-bottom: 2px solid #FF442F;
  font-weight: 600;
}
/*# sourceMappingURL=asset-profile-header.component.css.map */
